import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import './App.css'
import Home from './pages/Home'
import Speakers from './pages/Speakers'
import Schedule from './pages/Schedule'
import Venue from './pages/Venue'
import Sponsors from './pages/Sponsors'
import Register from './pages/Register'
import NotFound from './pages/NotFound'

function App() {
  return (
    <Router>
      <div className="App bg-gray-50 min-h-screen">
        <nav className="bg-primary text-white p-4 shadow-lg">
          <div className="container mx-auto flex gap-6 items-center">
            <Link to="/" className="text-xl font-bold hover:underline">Test Company</Link>
            <Link to="/" className="hover:underline">Home</Link>
            <Link to="/speakers" className="hover:underline">Speakers</Link>
            <Link to="/schedule" className="hover:underline">Schedule</Link>
            <Link to="/venue" className="hover:underline">Venue</Link>
            <Link to="/sponsors" className="hover:underline">Sponsors</Link>
            <Link to="/register" className="hover:underline">Register</Link>
          </div>
        </nav>
        <main className="min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/speakers" element={<Speakers />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/venue" element={<Venue />} />
          <Route path="/sponsors" element={<Sponsors />} />
          <Route path="/register" element={<Register />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        </main>
        <footer className="bg-gray-800 text-white p-8 mt-16">
          <div className="container mx-auto text-center">
            <p>&copy; {new Date().getFullYear()} Test Company. All rights reserved.</p>
            
          </div>
        </footer>
      </div>
    </Router>
  )
}

export default App
